import * as ActionType from '../../constants/actionType';

const initialState = {
  hubHost: {
    urlAuthoringLocation: `${window.location.protocol}//${window.location.host}`,
    urlLabwareDefinitionRepository: '',
    urlInstrumentControlLocation: '',
  },
  minAspirateVolume: {
    unit: 'µL',
    value: 0.1,
  },
  maxAspirateVolume: {
    unit: 'µL',
    value: 13,
  },
  recommendedAspirateVolume: {
    unit: 'µL',
    value: 0.1,
  },
  minAspirateHighVolume: {
    unit: 'µL',
    value: 0.1,
  },
  maxAspirateHighVolume: {
    unit: 'µL',
    value: 50,
  },
  recommendedAspirateHighVolume: {
    unit: 'µL',
    value: 3,
  },
  rangeAspirateSpeed: {
    unit: 'µL/s',
    minValue: 0.1,
    maxValue: 0.5,
  },
  rangeDispenseSpeed: {
    unit: 'µL/s',
    minValue: 0.1,
    maxValue: 0.5,
  },
  rangeMixingBeforeAspirateSpeed: {
    unit: 'µL/s',
    minValue: 0.1,
    maxValue: 0.5,
  },
  rangeMixingAfterDispenseSpeed: {
    unit: 'µL',
    minValue: 0.1,
    maxValue: 0.5,
  },
  rangeAspirateSpeedHV: {
    unit: 'µL/s',
    minValue: 0.1,
    maxValue: 0.5,
  },
  rangeDispenseSpeedHV: {
    unit: 'µL/s',
    minValue: 0.1,
    maxValue: 0.5,
  },
  rangeMixingBeforeAspirateSpeedHV: {
    unit: 'µL/s',
    minValue: 0.1,
    maxValue: 0.5,
  },
  rangeMixingAfterDispenseSpeedHV: {
    unit: 'µL',
    minValue: 0.1,
    maxValue: 0.5,
  },
  rangePrecisionDispenseSpeed: {
    unit: 'µL',
    minValue: 0.1,
    maxValue: 0.5,
  },
  rangeRetractAfterAspirateSpeed: {
    unit: 'µL',
    minValue: 0.1,
    maxValue: 0.5,
  },
  rangeRetractAfterDispenseSpeed: {
    unit: 'µL',
    minValue: 0.1,
    maxValue: 0.5,
  },
  dispenseAccuracyConfig: {
    volume: {
      value: 0,
      unit: 'μL',
    },
    speed: {
      value: 0,
      unit: 'μL/s',
    },
  },
  plateTypeEditorDeckInsert: 2,
  plateTypeEditorZPositionFromPlateSurface: 2,
  defaultTipPosition: 1,
  allowedTipDepth: 23,
  highVolumeAllowedTipDepth: 40,
  deepWellThreshold: 20,
  version: '0.0.1',
  '96Well': {
    tipPosition: 3,
    mixingPosition: 1,
    dispenseSpeed: 8,
    mixingSpeed: 8,
    mixingVolume: 5,
  },
  '384Well': {
    tipPosition: 4,
    mixingPosition: 1,
    dispenseSpeed: 8,
    mixingSpeed: 8,
    mixingVolume: 5,
  },
  protocolConfig: {
    nameMaxLength: 255,
    cardNameMaxLength: 25,
    deckLabwareNameMaxLength: 45,
    downloadFileNameMaxLength: 255,
  },
  labwareConfig: {
    nameMaxLength: 45,
  },
  minTipPosition: 0,
};

export default function configStateReducer(state = initialState, action = '') {
  switch (action.type) {
    case ActionType.SET_CONFIG: {
      return {
        ...state,
        ...action.config,
      };
    }
    default:
      return state;
  }
}
